import React, {Suspense} from 'react';
import styled from "styled-components";
import {useTranslation} from "react-i18next";
import useTitleAndDescription from "../../common/hooks/useTitleAndDescription";
import {Footer, Header, Loading} from "../common";
import {ErrorBoundary} from "react-error-boundary";
import CenterContentBox from "../Champions/ContentWrapper";
import BottomStickAd from "../ad/BottomStickAd";
import CustomClanContent from "./CustomClanContent";

const Wrapper = styled.div`
`;

const ContentWrapper = styled.div`
  min-height: 100px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;


function Fallback({error, resetErrorBoundary}) {
    // Call resetErrorBoundary() to reset the error boundary and retry the render.

    return (
        <div role="alert">
            <p>Something went wrong:</p>
            <pre>{error.message}</pre>
        </div>
    );
}

const CustomClan = () => {
    const {t} = useTranslation();
    useTitleAndDescription({
        title: 'CONNECT | Deeplol.gg',
        description: '리그 오브 레전드 내전 기록 자동 저장! 다양한 클랜, 크루, 스트리머 목록을 확인하고 함께 즐기세요.',
    })

    return (
        <Wrapper>
            <Header/>
            <ContentWrapper>
                <ErrorBoundary FallbackComponent={Fallback}>
                    <CenterContentBox disableSponsor={true}>
                        <Suspense fallback={<Loading/>}>
                            <CustomClanContent/>
                        </Suspense>
                        {/*    <NewsContent/>*/}
                    </CenterContentBox>
                </ErrorBoundary>
            </ContentWrapper>
            <Footer/>
            <BottomStickAd/>
        </Wrapper>
    );
};

export default CustomClan;